<template>
	<div class="container" id="codeView">
		<!-- 头部导航 -->
		<div class="header">
			<div class="nav-bar">
				<div class="nav-left">
					<img src="@/assets/ecny/Pandapass_logo.png" alt="Pandapass" class="logo" />
				</div>
				<div class="nav-right">
					<LanguageSwitch />
				</div>
			</div>
		</div>

		<!-- 主要内容区域 -->
		<div class="main-content">
			<!-- 熊猫AI按钮 -->
			<div class="panda-ai-button">
				<div class="ai-text">Pandapass AI</div>
				<div class="arrow-button">
					<img src="@/assets/code/arrow.png" alt="" />
				</div>
			</div>

			<!-- 睡眠熊猫图标和提示信息 -->
			<div class="panda-message-container" v-if="!isLogin || !isBuyPackage">
				<div class="sleeping-panda">
					<img src="@/assets/no_record.png" alt="Sleeping Panda" class="panda-image" />
				</div>

				<!-- 提示信息 -->
				<div class="message" v-if="!isLogin">
					{{ $t("codeView.notLoggedInMessage") }}
				</div>
				<div class="message" v-if="isLogin && !isBuyPackage">
					{{ $t("codeView.notBuyPackageMessage") }}
				</div>
			</div>
			<div class="panda-qrcode-container" v-else>
				<van-swipe :loop="false" :show-indicators="false" :initial-swipe="activeIndex" @change="onSwipeChange" :width="cardWidth" ref="swipe">
					<van-swipe-item></van-swipe-item>
					<van-swipe-item v-for="(card, index) in qrcodeCards" :key="index" :style="{ padding: '0 10px', transform: `translateX(calc(calc(${maxWidth}px - ${cardWidth}px - 40px) / 2))` }">
						<div class="qrcode" :class="{ inactive: card.status == 1 }">
							<div class="qrcode-btn-box">
								<div class="qrcode-btn-text">
									<div>{{ card.number }}</div>
								</div>
								<van-button class="qrcode-btn" v-if="card.status !== 1">
									{{ $t("codeView.goToUse") }}
								</van-button>
								<van-button class="qrcode-btn" v-else>
									{{ $t("codeView.expired") }}
								</van-button>
							</div>
							<!-- 二维码 -->
							<div class="qrcode-image">
								<QrcodeVue :value="card.qrcode" :size="qrcodeSize" level="H" />
							</div>
						</div>
						<div class="qrcode-error">
							<span v-if="card.status == 1">
								<van-icon name="warning-o" size="16" color="#EA2E17" />
								{{ $t("codeView.qrcodeError") }}
							</span>
						</div>
					</van-swipe-item>
					<van-swipe-item></van-swipe-item>
				</van-swipe>
			</div>

			<!-- 登录按钮 -->
			<div class="login-button-container" v-if="!isLogin">
				<van-button class="login-btn" @click="goToLogin">
					{{ $t("codeView.goToLogin") }}
				</van-button>
			</div>
			<div class="login-button-container" v-if="isLogin && !isBuyPackage">
				<van-button class="login-btn" @click="goToBuy">
					{{ $t("codeView.goToBuy") }}
				</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import "@vant/touch-emulator";
import LanguageSwitch from "@/components/LanguageSwitch.vue";
import { getUserInfoSafe, getToken, isLoggedIn, isBuyPackage as checkBuyPackage, requireLogin } from "@/utils/auth.js";
import QrcodeVue from "qrcode.vue";

export default {
	name: "CodeView",
	components: {
		LanguageSwitch,
		QrcodeVue,
	},
	data() {
		return {
			isLogin: false,
			isBuyPackage: false, //是否购买权益包
			userInfo: null,
			token: null,
			activeIndex: 1, // 当前激活的卡片索引
			cardWidth: 320,
			qrcodeCards: [],
			maxWidth: 430,
			qrcodeSize: 236, // 二维码大小
			resizeTimer: null, // 窗口大小变化防抖定时器
		};
	},
	mounted() {
		this.checkLogin();
		// 组件挂载后初始化
		console.log("二维码卡片数量:", this.qrcodeCards.length);
		this.maxWidth = window.innerWidth > 430 ? 430 : window.innerWidth;
		// 计算卡片宽度
		this.cardWidth = this.maxWidth - 40 - 56;
		// 计算二维码大小（根据卡片宽度自适应）
		this.calculateQrcodeSize();
		console.log("卡片宽度:", this.cardWidth, "二维码大小:", this.qrcodeSize);

		// 监听窗口大小变化
		window.addEventListener("resize", this.handleResize);
	},
	activated() {
		// 验证登录是否失效
		requireLogin(this);
		this.checkLogin();
	},
	beforeDestroy() {
		// 移除窗口大小变化监听
		window.removeEventListener("resize", this.handleResize);
	},
	methods: {
		goToLogin() {
			console.log("跳转到登录页面");
			this.$router.push("/login");
		},
		goToBuy() {
			if (!requireLogin(this)) return;
			console.log("跳转到购买页面");
			// //提示预览购买成功
			// this.$toast("购买成功");
			// this.isBuyPackage = true;
			//购买权益包逻辑
			this.$router.push({ name: "package-detail", query: { from: "code" } });
		},
		onSwipeChange(index) {
			// this.activeIndex = index;
			console.log("滑动切换，当前索引:", this.activeIndex, "总卡片数:", this.qrcodeCards.length);
			const lastIndex = this.qrcodeCards.length + 1; // 最后一张占位
			if (index >= lastIndex) {
				// 不允许滚动到最后一个，占位张
				this.$refs.swipe.swipeTo(lastIndex - 1);
			}
			if (index <= 0) {
				this.$refs.swipe.swipeTo(1);
			}
		},
		checkLogin() {
			// 重置状态，避免脏值残留
			this.isLogin = false;
			this.isBuyPackage = false;

			// 读取缓存（工具函数）
			this.userInfo = getUserInfoSafe();
			this.token = getToken();
			// 登录判定
			this.isLogin = isLoggedIn(this.userInfo, this.token);
			// 套餐判定
			this.isBuyPackage = checkBuyPackage(this.userInfo);
			// 已登录并购买后拉取二维码
			if (this.isLogin && this.isBuyPackage) {
				this.getQrcodeCards();
			}
		},
		requireLogin() {
			return requireLogin(this);
		},
		//处理窗口大小变化
		handleResize() {
			// 防抖处理，避免频繁计算
			clearTimeout(this.resizeTimer);
			this.resizeTimer = setTimeout(() => {
				this.maxWidth = window.innerWidth > 430 ? 430 : window.innerWidth;
				this.cardWidth = this.maxWidth - 40 - 56;
				this.calculateQrcodeSize();
				console.log("窗口大小变化 - 卡片宽度:", this.cardWidth, "二维码大小:", this.qrcodeSize);
			}, 100);
		},
		//计算二维码大小
		calculateQrcodeSize() {
			// 根据卡片宽度计算二维码大小
			// 二维码容器宽度 = 卡片宽度 - 左右padding(60px) - 左右margin(60px)
			const containerWidth = this.cardWidth - 50;
			// 二维码大小不超过容器宽度的90%，最小160px，最大280px
			this.qrcodeSize = Math.max(160, Math.min(280, Math.floor(containerWidth * 0.9)));
		},
		//获取二维码卡片
		getQrcodeCards() {
			if (!this.userInfo?.id) return;
			this.$api
				.postData("/qrcode/getQrcodeCards", { user_id: this.userInfo.id })
				.then((res) => {
					if (res && res.code === 200 && Array.isArray(res.data)) {
						this.qrcodeCards = res.data.map((row, idx) => ({
							number: idx + 1,
							status: Number(row.status),
							qrcode: row.qrcode,
							order_id: row.order_id,
							package_id: row.package_id,
						}));
						// 重置滑块到第一张有效卡片
						this.$nextTick(() => {
							this.activeIndex = 1;
							this.$refs.swipe && this.$refs.swipe.swipeTo(1);
						});
					}
				})
				.catch((err) => {
					console.error("getQrcodeCards error", err);
				});
		},

		//更新本地二维码状态
		updateLocalQrcodeStatus(qrcode, status) {
			const cardIndex = this.qrcodeCards.findIndex((card) => card.qrcode === qrcode);
			if (cardIndex !== -1) {
				this.qrcodeCards[cardIndex].status = status;
				// 触发响应式更新
				this.$forceUpdate();
			}
		},
	},
};
</script>

<style scoped lang="scss">
.container {
	min-height: 100vh;
	font-family: "D-DINExp";
	position: relative;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		height: 275px;
		background: url("@/assets/top_bj.png") no-repeat center top;
		background-size: cover;
		z-index: 1;
	}
}

.header {
	position: relative;
	z-index: 10;

	.nav-bar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px;
		background: transparent;

		.nav-left {
			display: flex;
			align-items: center;
			gap: 8px;

			.logo {
				width: 136px;
				height: auto;
			}
		}
	}
}

.main-content {
	padding: 20px 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0;
	position: relative;
	z-index: 10;

	.panda-ai-button {
		width: calc(100% - 68px);
		background: url("@/assets/code/bj.png") no-repeat center center;
		background-size: 100% 100%;
		border-top-left-radius: 20px;
		border-top-right-radius: 20px;
		padding: 20px 16px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);

		.ai-text {
			color: white;
			font-size: 18px;
			font-weight: bold;
		}

		.arrow-button {
			width: 40px;
			height: 40px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			transition: transform 0.2s ease;

			&:hover {
				transform: scale(1.1);
			}
			img {
				width: 100%;
				height: 100%;
			}
		}
	}

	.panda-message-container {
		text-align: center;
		height: 356px;
		width: 100%;
		background: #fff;
		border-radius: 20px;
		padding: 34px 24px;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		z-index: 12;
		position: relative;
		box-sizing: border-box;
		.sleeping-panda {
			position: relative;
			margin-bottom: 15px;
			.panda-image {
				width: 230px;
				height: 154px;
				object-fit: contain;
				margin: 0 auto;
				display: block;
			}
		}

		.message {
			font-size: 14px;
			line-height: 1.5;
			text-align: center;
			color: #333;
			min-height: 42px;
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
		}
	}

	.panda-qrcode-container {
		min-height: 453px;
		width: 100%;
		background: #fff;
		border-radius: 20px;
		overflow: hidden;
		position: relative;
		padding-top: 53px;

		.van-swipe {
			width: 100%;
			height: 100%;
		}

		.van-swipe-item {
			display: flex;
			justify-content: center;
			align-items: center;
			box-sizing: border-box;
			flex-direction: column;

			// padding: 0 10px;
			// transform: translateX(calc(calc(100% - 280px) * 2));
		}

		.qrcode {
			width: 100%;
			background: url("@/assets/code/qr_bg.png") no-repeat center center;
			background-size: 100% 100%;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			justify-content: space-between;
			color: #f7f0f0;
			font-weight: 600;
			font-size: 17px;

			&.inactive {
				background: url("@/assets/code/qr_bg_inactive.png") no-repeat center center;
				background-size: 100% 100%;
				.qrcode-btn-text {
					background: linear-gradient(90deg, #ccc6c6 0%, #ccc6c6 100%) !important;

					div {
						background: #fff !important;
						color: #808080;
					}
				}

				.qrcode-btn {
					color: #808080;
				}

				.qrcode-image {
					.image {
						opacity: 0.7;
						// 防止图片被拖动
						user-select: none;
						-webkit-user-drag: none;
						-khtml-user-drag: none;
						-moz-user-drag: none;
						-o-user-drag: none;
						pointer-events: none;
					}
				}
			}
			.qrcode-btn-box {
				width: 100%;
				height: 59px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				.qrcode-btn-text {
					width: 41px;
					height: 25px;
					background: linear-gradient(90deg, #ffd2cc 0%, #ffffff 100%);
					border-radius: 0px 12px 12px 0px;
					display: flex;
					justify-content: flex-end;
					align-items: center;
					padding-right: 2px;
					div {
						width: 22px;
						height: 22px;
						background: #ea2e17;
						border-radius: 50%;
						text-align: center;
						font-family: "D-DINExp-Bold";
					}
				}
			}
			.qrcode-btn {
				height: 38px;
				margin: 15px 18px 12px;
				font-family: "D-DINExp-Bold";
				background: transparent;
				border: none;
				color: #f7f0f0;
				font-weight: 600;
				font-size: 17px;
			}
			.qrcode-image {
				width: calc(100% - 60px);
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 36px 30px 32px;
				.image {
					width: 100%;
					object-fit: contain;
					object-position: center;
					// 防止图片被拖动
					user-select: none;
					-webkit-user-drag: none;
					-khtml-user-drag: none;
					-moz-user-drag: none;
					-o-user-drag: none;
					pointer-events: none;
				}
			}
		}
		.qrcode-error {
			margin-top: 20px;
			width: 100%;
			height: 20px;
			text-align: center;
		}
	}

	.login-button-container {
		width: 100%;
		max-width: 280px;
		margin-top: 20px;

		.login-btn {
			width: 100%;
			height: 50px;
			background: #ea2e17;
			color: white;
			border: none;
			border-radius: 25px;
			font-size: 16px;
			font-weight: bold;
			cursor: pointer;
			transition: background-color 0.3s ease;

			&:hover {
				background: #ff4757;
			}
		}
	}
}

@keyframes float {
	0%,
	100% {
		transform: translateY(0px);
	}
	50% {
		transform: translateY(-10px);
	}
}

@keyframes sleep {
	0%,
	100% {
		transform: rotate(-15deg) scale(1);
	}
	50% {
		transform: rotate(-15deg) scale(1.05);
	}
}
</style>
